import comp from "./PostSelection";
export default comp;
